// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../../fetch.pb.js";
export const EmailTemplateService = {
    /**
     * CreateEmailTemplate creates a new email template.
     */
    CreateEmailTemplate(fn, req) {
        return fn(`/messaging/bulk/email-template/v1/templates`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * UpdateEmailTemplate updates the email template.
     */
    UpdateEmailTemplate(fn, req) {
        try {
            fm.validateUrlParam(req["templateId"], "templateId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/email-template/v1/templates/${req["templateId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * UpdateEmailTemplate updates the email template locations
     */
    UpdateEmailTemplateLocations(fn, req) {
        try {
            fm.validateUrlParam(req["templateId"], "templateId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/email-template/v1/templates/${req["templateId"]}/locations`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * DeleteEmailTemplate deletes the email template. This is only a soft delete.
     */
    DeleteEmailTemplate(fn, req) {
        try {
            fm.validateUrlParam(req["templateId"], "templateId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/email-template/v1/templates/${req["templateId"]}?${fm.renderURLSearchParams(req, ["templateId"])}`, { method: "DELETE" });
    },
    /**
     * GetEmailTemplate gets a single template.
     */
    GetEmailTemplate(fn, req) {
        try {
            fm.validateUrlParam(req["templateId"], "templateId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/email-template/v1/templates/${req["templateId"]}?${fm.renderURLSearchParams(req, ["templateId"])}`, { method: "GET" });
    },
    /**
     * ListEmailTemplates gets a paginated list of email templates
     */
    ListEmailTemplates(fn, req) {
        return fn(`/messaging/bulk/email-template/v1/templates?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ListSystemTemplates does the same thing as ListEmailTemplates, but automatically populates the org_id and
     * business_group_ids fields in the request with the system location.
     * Returns a paginated list of system email templates that any location can use. template_json or template_html
     * will not be populated in the list of templates.
     */
    ListSystemTemplates(fn, req) {
        return fn(`/messaging/bulk/email-template/v1/system/templates?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
